export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/3fadfda14f341399d663fd2ed398d959.svg";